import React from "react";
import {
  RecognizeConnectContextValue,
  RecognizeConnectProviderProps,
  SpeechText,
} from "./RecognizeConnect.type";
import SpeechRecognize from "../../models/SpeechRecognize";
import {
  fSetDefaultGet,
  speechTextToEditTextRef,
} from "./recognize_connect_common";

const RecognizeConnect = React.createContext<RecognizeConnectContextValue>({
  textLang: "",
  setTextLang: fSetDefaultGet<string>(),
  speechRecognize: null,
  setSpeechRecognize: fSetDefaultGet<SpeechRecognize | null>(),
  speechText: { text: "" },
  setSpeechText: fSetDefaultGet<SpeechText>(),
  editTextRef: null,
  onEditChange: fSetDefaultGet<string>(),
});

export function RecognizeConnectProvider({
  children,
  initialText,
  inputRef,
  onChange,
  onSpeechText,
}: RecognizeConnectProviderProps) {
  const [textLang, setTextLang] = React.useState<string>("lat");
  const [speechRecognize, setSpeechRecognize] =
    React.useState<SpeechRecognize | null>(null);
  const [speechText, setSpeechText] = React.useState<SpeechText>({ text: "" });

  const [inputText, setInputText] = React.useState<string>(initialText ?? "");

  React.useEffect(() => {
    speechTextToEditTextRef(editTextRef, speechText, textLang);

    if (editTextRef !== null && editTextRef.current !== null) {
      setInputText(editTextRef.current.value);
    }
  }, [speechText]);

  let editTextRef = React.useRef<HTMLInputElement>(null);

  const onEditChange = React.useCallback(
    (text: string) => {
      setInputText(text);
    },
    [onChange]
  );

  React.useEffect(() => {
    if (
      initialText &&
      initialText !== "" &&
      editTextRef &&
      editTextRef.current
    ) {
      editTextRef.current.value = initialText;
    }
  }, [initialText]);

  React.useEffect(() => {
    if (onChange && editTextRef && editTextRef.current) {
      onChange(editTextRef.current.value);
      // console.log("useEffect - speechText", speechText);
    }
    if (editTextRef && editTextRef.current) {
      setInputText(editTextRef.current.value);
    }
  }, [onChange, editTextRef.current, editTextRef.current?.value, speechText]);

  React.useEffect(() => {
    if (onSpeechText && speechText && speechText.text.trim() !== "") {
      onSpeechText(speechText.text);
      // console.log("onSpeechText - speechText", speechText);
    }
  }, [onSpeechText, speechText]);

  React.useEffect(() => {
    // console.log("inputText", inputText);
    if (onChange) {
      onChange(inputText);
    }
    if (inputRef) {
      inputRef.current = inputText;
    }
  }, [inputText]);

  return (
    <RecognizeConnect.Provider
      value={{
        textLang,
        setTextLang,
        speechRecognize,
        setSpeechRecognize,
        speechText,
        setSpeechText,
        editTextRef,
        onEditChange,
      }}
    >
      {children}
    </RecognizeConnect.Provider>
  );
}

export default function useRecognizeConnect() {
  return React.useContext(RecognizeConnect);
}
